import Head from 'next/head';
import { memo } from 'react';

import { I18n } from '~/constants/I18n';

/**
 * Keeps a `<title>` mounted for pages that set none: next/head clears `document.title` when no `<title>` is mounted.
 * It must mount before page heads and never re-render or remount. next/head moves a `<Head>` to the end of its list
 * on every render and the last `<title>` wins, so this generic title would cover titles set with `NextSeo` or
 * `RegisteredDocumentTitleHead`.
 */
export const DefaultDocumentTitleHead = memo(() => (
  <Head>
    <title key="title">{I18n.basePageShortTitle}</title>
  </Head>
));

DefaultDocumentTitleHead.displayName = 'DefaultDocumentTitleHead';
